export enum SectionItemStatus {
  COMPLETE = 'complete',
  PARTIAL = 'partial',
  UNMAPPED = 'unmapped',
}
